import { render } from "./SweetModal.vue?vue&type=template&id=aed6fe72"
import script from "./SweetModal.vue?vue&type=script&lang=js"
export * from "./SweetModal.vue?vue&type=script&lang=js"

import "./SweetModal.vue?vue&type=style&index=0&id=aed6fe72&lang=scss"

import exportComponent from "../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__